import { Helmet } from 'react-helmet-async';

const SITE = 'https://uplsnipe.com';
const DEFAULT_IMG = `${SITE}/img/upllogo.png`;

const SEO = ({ title, description, keywords, path = '', image, type = 'website', jsonLd }) => {
  const fullTitle = title ? `${title} | UPL Snipe` : 'UPL Snipe — Industry-Led Tech Training, Live Projects & Placement Support';
  const url = `${SITE}${path}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={url} />

      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image || DEFAULT_IMG} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image || DEFAULT_IMG} />

      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
};

export default SEO;
